import Vue from 'vue';
// import VueDraggableResizable from 'vue-draggable-resizable';

/*
  подключаем все свг картинки
*/
import eyeOff from './svgs/eye_off.vue';
import eyeOn from './svgs/eye_on.vue';
import iconUpload from './svgs/icon-upload.vue';
import iconDownload from './svgs/icon-download.vue';
import iconClose from './svgs/icon-close.vue';
import iconSuccess from './svgs/icon-success.vue';
import iconPlay from './svgs/icon-play.vue';
import iconRemove from './svgs/icon-remove.vue';
import iconFilter from './svgs/icon-filter.vue';
import iconPlus from './svgs/icon-plus.vue';
import iconTxt from './svgs/icon-txt.vue';

import iconCv from './svgs/icon-cv.vue';
import iconLink from './svgs/icon-link.vue';
import iconLinkedin from './svgs/icon-linkedin.vue'; // TODO: удалить
import iconPhone from './svgs/icon-phone.vue';
import iconMail from './svgs/icon-mail.vue';
import iconCopy from './svgs/icon-copy.vue';

/*
  подключаем все глобальные компоненты
*/
import vcheckbox from './vcheckbox/index';
import vpassinfo from './vpassinfo/index';
import switcher from './switcher/index';
import vinput from './vinput/index';
import vtextarea from './vtextarea/index';
import vquill from './vquill/index';
import VcvEditor from './vcv-editor/index';
import vbutton from './vbutton/index';
import vcircle from './vcircle/index';
import multiselect from './multiselect/index';
import vcookiesNotification from './vcookies-notification/index';
import vfocusField from './vfocus-field/index';
import vpreloader from './vpreloader/index';
import vrecursiveBlock from './vrecursive-block/index';
import vuploadLogo from './vupload-logo/index';
import layout_popup from './layout_popup/index';
import vplayer from './vplayer/index';
import vaudio from './vaudio-player/index';
import vimg from './vimg/index';
import vtabs from './vtabs/index';

import vresume_button from './b2c/vresume-button/index';
import vresume_paginator from './b2c/vresume-paginator/index';
import vresume_questions from './b2c/vresume-questions/index';
import vresume_about_me from './b2c/vresume-about-me/index';
import vresume_modal from './b2c/vresume-modal/index';
import vresume_success from './b2c/vresume-success/index';

/*
  подключаем все сложные компоненты
*/
import vpassinput from './complex/vpassword_input.vue';
import vpassword from './complex/vpassword.vue';
import vchecklabel from './complex/vcheckbox_label.vue';
import vcirclelabel from './complex/vcircle_label.vue';
import vpagination from './complex/vpagination.vue';
import vuetify_pagination from './complex/vuetify-pagination.vue';
import vtake_interval_photos from './complex/vtake_interval_photos.vue';
import vrecorder from './complex/vrecorder.vue';
import vphone from './complex/vphone.vue';
import vtfilter from './complex/vtfilter.vue';
import vars_insert from './complex/vars_insert.vue';
import vtable from './complex/vtable.vue';
import vmodal from './complex/vmodal.vue';
import vslider from './complex/vslider.vue';
import vdate_range_slider from './complex/vdate_range_slider.vue';

/*
  регаем глобальные компоненты свг картинкок
*/
Vue.component('eye-off', eyeOff)
Vue.component('eye-on', eyeOn)
Vue.component('icon-upload', iconUpload)
Vue.component('icon-download', iconDownload)
Vue.component('icon-close', iconClose)
Vue.component('icon-success', iconSuccess)
Vue.component('icon-play', iconPlay)
Vue.component('icon-remove', iconRemove)
Vue.component('icon-filter', iconFilter)
Vue.component('icon-plus', iconPlus)
Vue.component('icon-txt', iconTxt)

Vue.component('icon-cv', iconCv)
Vue.component('icon-link', iconLink)
Vue.component('icon-linkedin', iconLinkedin)
Vue.component('icon-mail', iconMail)
Vue.component('icon-copy', iconCopy)
Vue.component('icon-phone', iconPhone)

/*
  регаем глобальные сложные компоненты
*/
Vue.component('vpassword', vpassword)
Vue.component('vpassinput', vpassinput)
Vue.component('vchecklabel', vchecklabel)
Vue.component('vcirclelabel', vcirclelabel)
Vue.component('vpagination', vpagination)
Vue.component('vuetify-pagination', vuetify_pagination)
Vue.component('vtake-interval-photos', vtake_interval_photos)
Vue.component('vphone', vphone)
Vue.component('vtfilter', vtfilter)
Vue.component('varsinsert', vars_insert)
Vue.component('vrecorder', vrecorder)
Vue.component('vtable', vtable)
Vue.component('vmodal', vmodal)
Vue.component('vslider', vslider)
Vue.component('vdate-range-slider', vdate_range_slider)

/*
  регаем глобальные компоненты
*/
Vue.component('vcheckbox', vcheckbox)
Vue.component('multiselect', multiselect)
Vue.component('vcookies-notification', vcookiesNotification)
Vue.component('vpassinfo', vpassinfo)
Vue.component('switcher', switcher)
Vue.component('vinput', vinput)
Vue.component('vtextarea', vtextarea)
Vue.component('vquill', vquill)
Vue.component('vcv-editor', VcvEditor)
Vue.component('vbutton', vbutton)
Vue.component('vcircle', vcircle)
Vue.component('vfocus-field', vfocusField)
Vue.component('vpreloader', vpreloader)
Vue.component('vrecursive-block', vrecursiveBlock)
Vue.component('vupload-logo', vuploadLogo)
Vue.component('lpopup', layout_popup)
Vue.component('vplayer', vplayer)
Vue.component('vaudio', vaudio)
Vue.component('vimg', vimg)

Vue.component('vtabs', vtabs)

Vue.component('vresume-button', vresume_button)
Vue.component('vresume-paginator', vresume_paginator)
Vue.component('vresume-questions', vresume_questions)
Vue.component('vresume-about-me', vresume_about_me)
Vue.component('vresume-modal', vresume_modal)
Vue.component('vresume-success', vresume_success)

/*
  регаем компоненты из npm
*/
// Vue.component('vue-draggable-resizable', VueDraggableResizable)
